export type ValidationTranslation = {
  answersCorrect: string;
  answersMin: string;
  answersSingleCorrect: string;
  categoryNameTaken: string;
  categoryPrefixTaken: string;
  email: string;
  expectedAnswersMax: string;
  expectedAnswersMin: string;
  expectedAnswersUnique: string;
  integer: string;
  maxDecimalPlaces_few?: string;
  maxDecimalPlaces_many?: string;
  maxDecimalPlaces_one: string;
  maxDecimalPlaces_other?: string;
  maxLength: string;
  maxNumber: string;
  minLength: string;
  number: string;
  numberRange: string;
  positionScopeRequired: string;
  positionsMin: string;
  positiveNumber: string;
  required: string;
  sapNumber: string;
  sourceLinkRepeated: string;
  sourceLinksMax: string;
  sourceLinkUrl: string;
  sourceRepeated: string;
  sourcesMax: string;
  sourceTypeRequired: string;
  surveyQuestionsMax: string;
  surveyQuestionType: string;
  tagTaken: string;
  testAttemptLimitRepeated: string;
  testCategoryRepeated: string;
  testExaminerQuestions: string;
  testPartsMax: string;
  testPurposeRequired: string;
  testQuestionsMax: string;
  testQuestionsMin: string;
  topicsMax: string;
  topicsMin: string;
  topicsToPickMax: string;
  topicsUnique: string;
};

export const validationTranslation: ValidationTranslation = {
  answersCorrect: 'Mark at least one correct answer.',
  answersMin: 'Add at least two answers.',
  answersSingleCorrect: 'Mark exactly one correct answer.',
  categoryNameTaken: 'A category with this name already exists. Letter case does not count.',
  categoryPrefixTaken: 'Another category already uses this prefix. Letter case does not count.',
  email: 'Enter a valid email address.',
  expectedAnswersMax: 'Add at most {{max}} expected answers.',
  expectedAnswersMin: 'Add at least one expected answer.',
  expectedAnswersUnique:
    'Each expected answer can appear only once. Letter case and spaces do not count.',
  integer: 'Enter a whole number.',
  maxDecimalPlaces_one: 'Use at most {{count}} decimal place.',
  maxDecimalPlaces_other: 'Use at most {{count}} decimal places.',
  maxLength: 'Use at most {{max}} characters.',
  maxNumber: 'Enter a number no greater than {{max}}.',
  minLength: 'Use at least {{min}} characters.',
  number: 'Enter a number.',
  numberRange: 'Enter a whole number from {{min}} to {{max}}.',
  positionScopeRequired: 'Choose who the question is for: all positions or selected ones.',
  positionsMin: 'Choose at least one position.',
  positiveNumber: 'Enter a number greater than zero.',
  required: 'This field is required.',
  sapNumber: 'Enter the SAP number using digits only.',
  sourceLinkRepeated: 'This procedure already has this link.',
  sourceLinksMax: 'Add at most {{max}} links to one procedure.',
  sourceLinkUrl: 'Enter a full address starting with http:// or https://.',
  sourceRepeated: 'The question already has this source.',
  sourcesMax: 'Add at most {{max}} sources.',
  sourceTypeRequired: 'Choose the source type.',
  surveyQuestionsMax: 'A survey can have at most {{max}} questions.',
  surveyQuestionType: 'Only single choice and open questions fit a survey. Remove the others.',
  tagTaken: 'This tag already exists. Letter case and spaces do not count.',
  testAttemptLimitRepeated: 'This position already has an exception.',
  testCategoryRepeated: 'This category is already in another part of the test.',
  testExaminerQuestions:
    'Questions graded by an examiner fit only a practical exam. Remove them or change the purpose of the test.',
  testPartsMax: 'Add at most {{max}} parts.',
  testPurposeRequired: 'Choose what the test is for.',
  testQuestionsMax: 'Choose at most {{max}} questions.',
  testQuestionsMin: 'Choose at least one question.',
  topicsMax: 'Add at most {{max}} topics.',
  topicsMin: 'Add at least one topic.',
  topicsToPickMax:
    'The examiner cannot pick more topics than the list has. Add topics or lower this number.',
  topicsUnique: 'Each topic can appear only once. Letter case and spaces do not count.',
};
